import { Flex, Box, H1 } from '../../components';
import { useSettingsQuery } from '../../lib/core/SettingsQuery';
import Products from './Products';
import Checkout from './Checkout';
import CurrentUserSubscription from './CurrentUserSubscription';
import { CheckoutValueContextProvider } from '../CheckoutValueContext';
import { buyProductPageQuery_buyProductPage } from '../../core-types';

type Props = {
  productSlug?: string;
  step?: string;
  listName: string | null;
  urlQuery: Record<string, any>;
  buyProductPage: buyProductPageQuery_buyProductPage | null;
};

const BuyProduct = ({
  productSlug,
  step,
  urlQuery,
  buyProductPage,
  listName
}: Props) => {
  const { data: settingsData } = useSettingsQuery();
  if (!settingsData || !settingsData.settings) {
    return null;
  }
  const { settings } = settingsData;

  let headingTitle;
  if (buyProductPage) {
    headingTitle = buyProductPage.heading || buyProductPage.title;
  }

  if (productSlug) {
    return (
      <CheckoutValueContextProvider storageKey="BuyProductCheckout">
        <Checkout
          productSlug={productSlug}
          step={step}
          privacyPageSlug={
            settings.privacyPageSlug && settings.privacyPageSlug.current
          }
          urlQuery={urlQuery}
          listName={listName}
        />
      </CheckoutValueContextProvider>
    );
  }

  return (
    <Box ml="auto" mr="auto" maxWidth={980} width="100%" mt="lg">
      <Flex alignItems="center" column justifyContent="center" mx="xxs">
        <H1 color="primaryContrast" mb="md">
          {headingTitle}
        </H1>
        <CurrentUserSubscription />
        <Box width={{ md: 1 }}>
          <Products listName={listName} />
        </Box>
      </Flex>
    </Box>
  );
};

export default BuyProduct;
